import { useEffect } from 'react';

import { usePayment } from '@/core/api/payments';
import type {
	Form,
	InwardDetails,
	InwardMessage,
	NestedProfile,
	OutwardDetails,
	OutwardInstruction,
} from '@/core/types/payments';

export function useNestedPaymentForms(paymentObjectName: string) {
	const { data, isPending, isError, error, status, fetchStatus } = usePayment(paymentObjectName);

	const profile = data?.nestedRelation.find((r) => r.object.archetype === 'profile')?.object as
		| NestedProfile
		| undefined;

	useEffect(() => {
		console.group(`[PaymentDetails] useNestedPaymentForms — ${paymentObjectName}`);
		console.log('query status:', status, '| fetchStatus:', fetchStatus);
		console.log('isPending:', isPending, '| isError:', isError);
		if (isError) console.error('query error:', error);
		if (data === null) {
			console.warn('data is null — payment not found (get[] returned empty array)');
		} else if (data) {
			const archetypes = data.nestedRelation.map((r) => `${r.object.archetype}/${r.object.kind ?? '—'}`);
			console.log('nestedRelation archetypes:', archetypes);
			if (!profile) {
				console.warn('profile not found in nestedRelation');
			} else {
				console.log('profile id:', profile.id, '| name:', profile.labels?.name ?? '—');
				if (!profile.id) console.warn('profile id is empty — broken reference');
			}
		}
		console.groupEnd();
	}, [data, isPending, isError]);

	const nestedForms = data?.nestedRelation.filter((r) => r.object.archetype === 'form').map((r) => r.object) ?? [];

	const inwardForm = nestedForms.find((f) => f.kind === 'inward_message') as Form<InwardMessage> | undefined;

	const outwardForm = nestedForms.find((f) => f.kind === 'outward_instruction') as Form<OutwardInstruction> | undefined;

	const inwardDetails = nestedForms.find((f) => f.kind === 'inward_details') as Form<InwardDetails> | undefined;

	const outwardDetails = nestedForms.find((f) => f.kind === 'outward_details') as Form<OutwardDetails> | undefined;

	return {
		profile,
		inwardForm,
		outwardForm,
		inwardDetails,
		outwardDetails,
		isPending,
	};
}
